import * as moment from "moment"
import * as lookup from "../../../../../static/lookup.json"
import * as dataLayerLookup from "../../../../../static/dataLayerEventTrigger.json"
import { getAge } from "../../helperFunctions"
import { MD5 } from "crypto-js"

export function gspDataLayer (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)  {
    console.log(journeyState);
    let journeyId = journeyState?.journeyIdFromStrapi
    let allJourneyData = allJourneyDataResponse
    let lastDataLayerElement
    let dynamicEvent
    var clientId
    try {
      let cookies = document.cookie
      let cookieArray = cookies.split(";")
      if (cookieArray && cookieArray.length) {
          let gaTagCookie = cookieArray.find(element => {
          if (element.includes("_ga=")) {
            return element.split(".")
          }
        })
        if (gaTagCookie) {
            let gaTagCookieSplit = gaTagCookie.split(".")
            if (gaTagCookieSplit && gaTagCookieSplit.length) {
                clientId = `${gaTagCookieSplit[gaTagCookieSplit.length - 2]}.${
                    gaTagCookieSplit[gaTagCookieSplit.length - 1]
                }`
          } else {
            clientId = ""
        }
        } else {
          clientId = ""
        }
    } else {
        clientId = ""
    }
    } catch (err) {
      console.log("Error geting google tag", "err")
    }
    window.dataLayer = window.dataLayer || [];
    if(window.dataLayer.length){
        lastDataLayerElement = window.dataLayer[window.dataLayer.length -1]
    }else{
        lastDataLayerElement = {}
    }
    let premium = journeyState?.gurantedSavingsBiKeys?.premiumAmount
    let premiumFrequency = allJourneyData?.productDetails?.premiumFrequency
    let policyTerm = allJourneyData?.productDetails?.policyTerm
    let totalMonthlyPremium
    if(premiumFrequency === "12"){
      totalMonthlyPremium = Number(premium/12)
    }else if(premiumFrequency === "01"){
      totalMonthlyPremium = Number(premium)
    }else if(premiumFrequency === "03"){
      totalMonthlyPremium = Number(premium/4)
    }else if(premiumFrequency === "06"){
      totalMonthlyPremium = Number(premium/6)
    }else if(premiumFrequency === "SG"){
      totalMonthlyPremium = Number((premium/policyTerm)/12)
    }
    let tax
    if(totalMonthlyPremium){
      tax = Number(totalMonthlyPremium - Math.round(premium/1.18))
    }

    let monthlyPremium
    if(totalMonthlyPremium && tax ){
      monthlyPremium = totalMonthlyPremium - tax
    }

    if(e === "previous"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.previousButtonEvent?.eventName 
    }else if(e === "proceed"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.proceedButtonEvent?.eventName
    }else if(e === "landing"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.landingPageEvent?.eventName
    }else {
        console.log(dataLayerLookup)
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.componentKeyEvent?.[componentFormControlKey]?.eventName
    }
    let pageNameHaveSource = window.location.href?.includes("source")
    if(dynamicEvent === "GSP_Buy_PersonalDetail_Landed" && !pageNameHaveSource){
        return 
    }
    console.log(dataLayerLookup?.[journeyId]?.[sectionId]);
    console.log(dataLayerLookup?.[journeyId]?.[sectionId]?.sectionName);

    let biJson = journeyState?.gurantedSavingsBiKeys?.biJson ? journeyState?.gurantedSavingsBiKeys?.biJson : null
    if(dynamicEvent){
        window.dataLayer.push({
            "event" : dynamicEvent,
            "ProductName": "Guaranteed Savings Plan",
            "ProductCategory": "Saving",
            "ProductSubCategory": "Protection",
            "ProductCode": "90007",
            "PageType": "Buying Journey",
            "PageName": window.location.href,
            "PolicyType": "Savings",
            "SectionName": dataLayerLookup?.[journeyId]?.[sectionId]?.sectionName,
            "ClientID": clientId,
            "Source": journeyState?.channel ? journeyState?.channel : "n/a",
            "Usertype": allJourneyData?.basicDetails?.existingCustomer ? allJourneyData?.basicDetails?.existingCustomer === "N" ? "New User" : "Returning User" : "n/a",
            "MobileNumber": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ? MD5(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo)?.toString() : "n/a",
            "EmailID": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ? MD5(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId)?.toString() : "n/a",
            "Gender": allJourneyData?.lifeAssuredDetails?.gender ? lookup?.["gender"]?.[0][allJourneyData?.lifeAssuredDetails?.gender] : "n/a",
            "DOB": allJourneyData?.lifeAssuredDetails?.dob ? moment.unix(allJourneyData?.lifeAssuredDetails?.dob).format('MM/YYYY') : "n/a",
            "Age": allJourneyData?.lifeAssuredDetails?.dob ? getAge(allJourneyData?.lifeAssuredDetails?.dob) : "n/a",
            "TobaccoConsumer": allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking ? lookup?.["yesNo"][0][allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking] : "n/a",
            "Education": allJourneyData?.lifeAssuredDetails?.employmentDetails?.education ? lookup?.["education"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.education] : "n/a",
            "AnnualIncome": allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome ? Number(allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome) : "n/a",
            "ApplicationNumber": allJourneyData?.basicDetails?.applicationNumber ? allJourneyData?.basicDetails?.applicationNumber : "n/a",
            "SumAssured": journeyState?.gurantedSavingsBiKeys?.gurantedSumAssured ? journeyState?.gurantedSavingsBiKeys?.gurantedSumAssured : "n/a",
            "Term": allJourneyData?.productDetails?.policyTerm ? Number(allJourneyData?.productDetails?.policyTerm) : "n/a",
            "PremiumPaymentTerm": allJourneyData?.productDetails?.premiumPaymentTerm ? allJourneyData?.productDetails?.premiumPaymentTerm : "n/a",
            "PaymentFrequency": allJourneyData?.productDetails?.premiumFrequency ? lookup?.["premiumFrequency"][0][allJourneyData?.productDetails?.premiumFrequency] : "n/a",
            // "MonthlyPremium": allJourneyData?.productDetails?.premiumFrequency === "01" ? journeyState?.gurantedSavingsBiKeys?.premiumAmount : "n/a",
            // "TotalMonthlyPremium": allJourneyData?.productDetails?.premiumFrequency === "01" && biJson ? Math.round(biJson?.[0].MODAL_PREM_TAX) : "n/a",
            "Country": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap ? lookup?.["countryCodeToCountry"]?.[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap] : "n/a",
            "ResidentialStatus": allJourneyData?.lifeAssuredDetails?.residentStatus ? lookup?.["residentStatus"][0][allJourneyData?.lifeAssuredDetails?.residentStatus] : "n/a",
            "PinCode": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode : "n/a",
            "State": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state ? lookup?.["state"][0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state] : "n/a",
            "Occupation": allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation ? lookup?.["occupation"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation] : "n/a",
            "NatureOfDuties": allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation ? lookup?.["natureOfOccupation"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation] : "n/a",
            "ExistingSumAssured": allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.sumAssured ? allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.sumAssured : "n/a",
            "PlanOption": allJourneyData?.productDetails?.planOption ? lookup?.["planOption"]?.[0][allJourneyData?.productDetails?.planOption] : "n/a",
            "PaymentOption":journeyState?.paymentStep ? journeyState?.paymentStep === "N" ? "paynow": "paylater" : "n/a",
            "PaymentMode": journeyState?.paymentDecryptData?.paymentMethod ? journeyState?.paymentDecryptData?.paymentMethod : "n/a",
            "NatureOfIndustry": allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry ? lookup?.["natureOfIndustry"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry] : "n/a",
            "Premium": journeyState?.gurantedSavingsBiKeys?.premiumAmount ? journeyState?.gurantedSavingsBiKeys?.premiumAmount : "n/a",
            "TotalPremium": biJson ? Math.round(biJson?.[0].MODAL_PREM_TAX) : "n/a",
            "GuaranteedAdditions": journeyState?.gurantedSavingsBiKeys?.expectedBonusAmount ? journeyState?.gurantedSavingsBiKeys?.expectedBonusAmount : "n/a",
            // "YearlyPremium": allJourneyData?.productDetails?.premiumFrequency !== "03" && allJourneyData?.productDetails?.premiumFrequency !== "06" ? journeyState?.gurantedSavingsBiKeys?.premiumAmount ? journeyState?.gurantedSavingsBiKeys?.premiumAmount : "n/a" : "n/a",
            "order_ID": journeyState?.paymentDecryptData?.paymentTxnId ? journeyState?.paymentDecryptData?.paymentTxnId : "n/a",
            "InsuranceRepository": allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository ? lookup?.["insuranceRepository"]?.[0][allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository] : "n/a",
            "PreviousInsuranceCompany": allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.insuranceCompany ? allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.insuranceCompany : "n/a",
            "MatuarityValue": journeyState?.gurantedSavingsBiKeys?.maturityBenefit ? journeyState?.gurantedSavingsBiKeys?.maturityBenefit : "n/a",
            "Name": allJourneyData?.lifeAssuredDetails?.fullName ? allJourneyData?.lifeAssuredDetails?.fullName : "n/a",
            "NomineeDOB1": allJourneyData?.nominees?.[0]?.dob ? moment.unix(allJourneyData?.nominees?.[0]?.dob).format('MM/YYYY') : "n/a",
            "NomineeDOB2": allJourneyData?.nominees?.[1]?.dob ? moment.unix(allJourneyData?.nominees?.[1]?.dob).format('MM/YYYY') : "n/a",
            "NomineeDOB3": allJourneyData?.nominees?.[2]?.dob ? moment.unix(allJourneyData?.nominees?.[2]?.dob).format('MM/YYYY') : "n/a",
            "NomineeDOB4": allJourneyData?.nominees?.[3]?.dob ? moment.unix(allJourneyData?.nominees?.[3]?.dob).format('MM/YYYY') : "n/a",
            "NomineeEmail1": allJourneyData?.nominees?.[0]?.emailId ? MD5(allJourneyData?.nominees?.[0]?.emailId)?.toString() : "n/a",
            "NomineeEmail2": allJourneyData?.nominees?.[1]?.emailId ? MD5(allJourneyData?.nominees?.[1]?.emailId)?.toString() : "n/a",
            "NomineeEmail3": allJourneyData?.nominees?.[2]?.emailId ? MD5(allJourneyData?.nominees?.[2]?.emailId)?.toString() : "n/a",
            "NomineeEmail4": allJourneyData?.nominees?.[3]?.emailId ? MD5(allJourneyData?.nominees?.[3]?.emailId)?.toString() : "n/a",
            "NomineeGender1": allJourneyData?.nominees?.[0]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[0]?.gender] : "n/a",
            "NomineeGender2": allJourneyData?.nominees?.[1]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[1]?.gender] : "n/a",
            "NomineeGender3": allJourneyData?.nominees?.[2]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[2]?.gender] : "n/a",
            "NomineeGender4": allJourneyData?.nominees?.[3]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[3]?.gender] : "n/a",
            "NomineeMobileNumber1": allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"] ? MD5(allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"])?.toString() : "n/a",
            "NomineeMobileNumber2": allJourneyData?.nominees?.[1]?.["contactDetails.mobileNo"] ? MD5(allJourneyData?.nominees?.[1]?.["contactDetails.mobileNo"])?.toString() : "n/a",
            "NomineeMobileNumber3": allJourneyData?.nominees?.[2]?.["contactDetails.mobileNo"] ? MD5(allJourneyData?.nominees?.[2]?.["contactDetails.mobileNo"])?.toString() : "n/a",
            "NomineeMobileNumber4": allJourneyData?.nominees?.[3]?.["contactDetails.mobileNo"] ? MD5(allJourneyData?.nominees?.[3]?.["contactDetails.mobileNo"])?.toString() : "n/a",
            "NomineeRelationship1": allJourneyData?.nominees?.[0]?.relationshipWithLa ? allJourneyData?.nominees?.[0]?.gender === "M" ? lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa] : lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa] : "n/a",
            "NomineeRelationship2": allJourneyData?.nominees?.[1]?.relationshipWithLa ? allJourneyData?.nominees?.[1]?.gender === "M" ? lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[1]?.relationshipWithLa] : lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[1]?.relationshipWithLa] : "n/a",
            "NomineeRelationship3": allJourneyData?.nominees?.[2]?.relationshipWithLa ? allJourneyData?.nominees?.[2]?.gender === "M" ? lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[2]?.relationshipWithLa] : lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[2]?.relationshipWithLa] : "n/a",
            "NomineeRelationship4": allJourneyData?.nominees?.[3]?.relationshipWithLa ? allJourneyData?.nominees?.[3]?.gender === "M" ? lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[3]?.relationshipWithLa] : lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[3]?.relationshipWithLa] : "n/a",
            "ProposerMarritalStatus": allJourneyData?.proposerDetails?.maritalStatus ? lookup?.["martialStatus"][0][allJourneyData?.proposerDetails?.maritalStatus] : "n/a",
            "ProposerSame": allJourneyData?.lifeAssuredDetails?.isLaAndPropSame ? lookup?.["yesNo"][0][allJourneyData?.lifeAssuredDetails?.isLaAndPropSame] : "n/a",
            'NachStatus': (allJourneyData?.basicDetails?.enachSuccess === true) ? "Success" : (allJourneyData?.basicDetails?.enachSuccess === false ? "Fail" : "n/a"),
            'NachType': (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true) ? "Physical Mandate" : (allJourneyData?.basicDetails?.isPhysicalMandateOpt === false ? "E-Mandate" : "n/a")
        })
    }
}

export function gspTransactionDataLayer (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState) {
    const dateofbirth = allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.dob;
    const formatedDob = moment.unix(dateofbirth).format('MM/YYYY');
    const AGE = getAge(dateofbirth);
    const emailID = allJourneyDataResponse?.journeyData?.basicDetails?.emailID;
    const mobileNo = allJourneyDataResponse?.journeyData?.basicDetails?.mobileNo;
    let encryptedEmail 
    let encryptedMobileNo
    try {
      encryptedEmail = MD5(emailID)?.toString();
      console.log(encryptedEmail, "encryptedEmail")
      encryptedMobileNo = MD5(mobileNo)?.toString();
      console.log(encryptedMobileNo, "encryptedMobileNo")
    }catch(err){
      console.log(err, "dsds")
    }
    
    const transactions = allJourneyDataResponse?.journeyData?.transactionDetails?.transactions
    const applicationNoGenerationTime = allJourneyDataResponse?.journeyData?.basicDetails?.applicationNoGenerationTime
    const policyTerm = Number(allJourneyDataResponse?.journeyData?.productDetails?.policyTerm)
    const policyTermInSeconds = 31556926 * policyTerm
    const policyStartDateCalc = moment.unix(applicationNoGenerationTime)?.format("DD-MM-YYYY")
    const policyEndDateCalc = moment.unix(applicationNoGenerationTime + policyTermInSeconds)?.format("DD-MM-YYYY")
    const riders = allJourneyDataResponse?.journeyData?.productDetails?.riders?.rider
    let addOnsCalc
    if(riders.length){
      let riderNames = riders?.map(eachRider => eachRider.name)
      addOnsCalc = riderNames.join("_")
    }else{
      addOnsCalc = ""
    }
    
    var PaymentMode = transactions?.[transactions.length -1]?.paymentMethod;         //Credit Card/Debit Card/Internet Banking/UPI
    var PolicyType = allJourneyDataResponse?.journeyData?.productDetails?.productType;
    var PolicyStartDate =  policyStartDateCalc;
    var PolicyEndDate = policyEndDateCalc;
    var PolicyNo = allJourneyDataResponse?.journeyData?.basicDetails?.applicationNumber;
    var SumInsured = allJourneyDataResponse?.journeyData?.productDetails?.sumAssured;
    var QuoteNo = allJourneyDataResponse?.journeyData?.basicDetails?.illustrationNumber;              //Quotation Number
    var Age = AGE;
    var Gender = lookup.gender[0][allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.gender];
    var PaymentFrequency = allJourneyDataResponse?.journeyData?.paymentFrequency;
    var PremiumAmount = allJourneyDataResponse?.journeyData?.premium;
    var AdditionalBenefit = addOnsCalc;
    var ID1 = encryptedMobileNo;                //Encrypted Mobile Number of the user
    var ID2 = encryptedEmail;                 //Encrypted Email ID of the user
    var DOB = formatedDob;                 //MM/YYYY momentfucntion
    var TobaccoConsumer = allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.personalDetails?.smoking === "N" ? "No" :  "Yes"   //Yes/No
    var ApplicationNumber = allJourneyDataResponse?.journeyData?.basicDetails?.applicationNumber;
    var Addons = addOnsCalc;
    var PaymentOption = allJourneyDataResponse?.journeyData?.paymentStep === "N" ? "paynow" : "paylater";
    var ProductCode = '90073';
    var ProductCategory = 'Term';
    var ProductSubCategory = 'Protection';
    var State = lookup.state[0][allJourneyDataResponse?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state];       //State where purchase is made
    var products = [];
    products.push({
      'name': 'Guaranteed Savings Plan',
      'id': '90007',                               //Product Code
      'category': 'Savings',                     //Category of the Product
      'price': allJourneyDataResponse?.journeyData?.premium,                  //Product Price
      'quantity': '1'                         //Number of Products Purchased
    })

    var items = [];
    items.push({
        'item_id': "90007", //HSN Code/ITEM Code
        'item_name': "Guaranteed Savings Plan",
        'currency': "INR",
        'item_brand': "CanaraHSBC",
        'item_category': "Savings", //Product Category
        'item_category2': "Protection", //Product SubCategory
        'price': allJourneyDataResponse?.journeyData?.premium, //individual product price
        'quantity': 1
    })

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': transactions?.[transactions.length -1]?.paymentTxnId,               //Transaction ID (String)
            'affiliation': 'Online Journey',      //Affiliation or Store Name
            'revenue': allJourneyDataResponse?.journeyData?.premium,                 //Total Revenue (inclusive of tax., shipping, etc.) (number) - Premium
            'tax': allJourneyDataResponse?.journeyData?.productDetails?.premServiceTax,
            'shipping': '',
            'coupon': ''
          },
          'products': products
        }
      }
    });
    window.dataLayer.push({
        'event': "purchase",
        'ecommerce': {
            'transaction_id': transactions?.[transactions.length -1]?.paymentTxnId, // Unique transaction id of every purchase
            'affiliation': "Online Journey",
            'value': allJourneyDataResponse?.journeyData?.premium, // total booking amaount
            'tax': allJourneyDataResponse?.journeyData?.productDetails?.premServiceTax, // tax on booking
            'currency': "INR",
            'coupon': "", //Coupon/Promo Code
            'discount': 0,
            'payment_type': transactions?.[transactions.length -1]?.paymentMethod,
            'items': items
        }
    })
}